<template>
  <div class="transform">
    <common-layout>
      <div slot="header">
        <h3>产学研科技合作基地</h3>
      </div>
      <div slot="container">
        <div class="transform-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623aa2; border: none"
            >新增</el-button
          >
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll"
            >批量删除</el-button
          >
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
            style="width: 240px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <label>技术领域:</label>
          <el-select
            style="width: 140px"
            v-model="fieldValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in fieldOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <label>级别:</label>
          <el-select
            style="width: 140px"
            v-model="levelValue"
            clearable
            placeholder="全部"
            @change="search"
          >
            <el-option
              v-for="item in levelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="transform-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
              type="index"
              width="150"
              label="序号"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="名称" align="center" prop="name">
            </el-table-column>
            <el-table-column label="基地简介" align="center">
              <template slot-scope="scope">
                <span style="display: block; height: 23px; overflow: hidden">{{
                  GetTarg(scope.row.introduction)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="日期" align="center" prop="date_time">
            </el-table-column>
            <el-table-column label="是否推荐" align="center" prop="hot">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.hot == 1" type="success" effect="plain">
                  是
                </el-tag>
                <el-tag v-else type="danger" effect="plain"> 否 </el-tag>
              </template>
            </el-table-column>
            <el-table-column width="240px" align="center" label="操作">
              <template slot-scope="scope">
                <!-- <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.hot == 2"
                >推荐资源</el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>取消推荐</el-button> -->
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        >
        </el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="机构名称" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入机构名称"
                ></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="级别" prop="level">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.level"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in levelOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item
                label="从事的主要技术和产业领域"
                prop="field"
                class="special"
              >
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.field"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in fieldOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <!-- <el-row>
            <el-form-item
              label="服务人数"
              prop="people"
            >
              <el-input
                v-model="ruleForm.people"
                placeholder="请输入服务人数"
              ></el-input>
            </el-form-item>
          </el-row> -->
            <el-row>
              <el-form-item label="单位类型" prop="A026">
                <el-select
                  multiple
                  style="width: 100%"
                  v-model="ruleForm.A026"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in dwlxOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="logo" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img
                  v-if="ruleForm.logo"
                  :src="imgUrl + ruleForm.logo"
                  class="img_border"
                  v-real-img="ruleForm.logo"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.logo }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.logo">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="申报单位名称" prop="subject">
              <el-input
                v-model="ruleForm.subject"
                placeholder="请输入申报单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合作单位" prop="unit">
              <el-input
                v-model="ruleForm.unit"
                placeholder="请输入合作单位"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="通讯地址" prop="detailed">
            <v-distpicker
              style="text-align: left"
              @selected="citySelected"
              :province="ruleForm.address.province.value"
              :city="ruleForm.address.city.value"
              :area="ruleForm.address.area.value"
            ></v-distpicker>
            <el-input
              style="margin-top: 10px"
              v-model="ruleForm.detailed"
              placeholder="请填写详细地址"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="实景图" style="text-align: center">
            <el-upload
              style="text-align: left"
              :action="this.uploadURL"
              list-type="picture-card"
              :file-list="fileList"
              :on-preview="pictureCardPreview1"
              :before-upload="beforeUpload1"
              :on-remove="handleRemove1"
              :http-request="HouImgFile1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="办公场所面积(平方米)" class="special">
              <el-input
                v-model="ruleForm.A001"
                placeholder="请填写办公场所面积"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生产或示范基地面积(平方米)" class="special">
              <el-input
                v-model="ruleForm.A003"
                placeholder="请填写生产或示范基地面积"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科研仪器设备价值总额(万元)" class="special">
              <el-input
                v-model="ruleForm.A002"
                placeholder="请填写科研仪器设备价值总额"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="资产总额(万元)">
              <el-input
                v-model="ruleForm.A004"
                placeholder="请填写资产总额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="固定资产(万元)">
              <el-input
                v-model="ruleForm.A005"
                placeholder="请填写固定资产"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流动资产(万元)">
              <el-input
                v-model="ruleForm.A006"
                placeholder="请填写流动资产"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="科技成果推介会(场)" class="special">
              <el-input
                v-model="ruleForm.A036"
                placeholder="请填写科技成果推介会数"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单位职工数(人)">
              <el-input
                v-model="ruleForm.A007"
                placeholder="请填写单位职工数"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科技活动人员数(人)" class="special">
              <el-input
                v-model="ruleForm.A008"
                placeholder="请填写科技活动人员数"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="高级职称(人)">
              <el-input
                v-model="ruleForm.A009"
                placeholder="请填写高级职称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="中级职称(人)">
              <el-input
                v-model="ruleForm.A010"
                placeholder="请填写中级职称"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="博士(人)">
              <el-input
                v-model="ruleForm.A011"
                placeholder="请填写博士"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="硕士(人)">
              <el-input
                v-model="ruleForm.A012"
                placeholder="请填写硕士"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="初级职称(人)">
              <el-input
                v-model="ruleForm.A013"
                placeholder="请填写初级职称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="无职称(人)">
              <el-input
                v-model="ruleForm.A014"
                placeholder="请填写无职称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="本科(人)">
              <el-input
                v-model="ruleForm.A015"
                placeholder="请填写本科"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="本科以下(人)">
              <el-input
                v-model="ruleForm.A016"
                placeholder="请填写本科以下"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="收入(万元)">
              <el-input
                v-model="ruleForm.A017"
                placeholder="请填写收入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支出(万元)">
              <el-input
                v-model="ruleForm.A018"
                placeholder="请填写支出"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="人员费用">
              <el-input
                v-model="ruleForm.A019"
                placeholder="请填写人员费用"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="科研业务费">
              <el-input
                v-model="ruleForm.A020"
                placeholder="请填写科研业务费"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="利润总额(万元)">
              <el-input
                v-model="ruleForm.A021"
                placeholder="请填写利润总额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所得税费用(万元)">
              <el-input
                v-model="ruleForm.A022"
                placeholder="请填写所得税费用"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="资产负债率(%)">
              <el-input
                v-model="ruleForm.A023"
                placeholder="请填写资产负债率"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item
            label="本单位的基本情况与工作基础"
            prop="introduction"
            class="special"
          >
            <!-- <editor refName='introduction' :placeholder="'请填写本单位的基本情况与工作基础'" :quill-data="ruleForm.introduction" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
            <editor
              refName="introduction"
              :placeholderText="'请填写本单位的基本情况与工作基础'"
              v-model="ruleForm.introduction"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <!-- <el-row>
        <el-form-item label="产出情况" prop="output">
          	<editor refName='output' :placeholder="'请填写近三年技术引进和成果产出情况'" :quill-data="ruleForm.output" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData1"></editor>
        </el-form-item>
      </el-row> -->
        <el-row>
          <el-form-item
            label="申报产学研科技合作基地（企业研发机构）的目的"
            prop="A024"
            class="special"
          >
            <!-- <editor refName='A024' :placeholder="'请填写申报产学研科技合作基地（企业研发机构）的目的'" :quill-data="ruleForm.A024" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData1"></editor> -->
            <editor
              refName="A024"
              :placeholderText="'请填写申报产学研科技合作基地（企业研发机构）的目的'"
              v-model="ruleForm.A024"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="产学研科技合作基地（企业研发机构）的功能定位"
            prop="A025"
            class="special"
          >
            <!-- <editor refName='A025' :placeholder="'请填写说明集成、示范、熟化、中试、二次研发、标准化示范等以及在区域或行业中地位与作用'" :quill-data="ruleForm.A025" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData4"></editor> -->
            <editor
              refName="A025"
              :placeholderText="'请填写说明集成、示范、熟化、中试、二次研发、标准化示范等以及在区域或行业中地位与作用'"
              v-model="ruleForm.A025"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="合作单位基本情况" prop="company" class="special">
            <!-- <editor refName='company' :placeholder="'请填写合作单位基本情况'" :quill-data="ruleForm.company" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData2"></editor> -->
            <editor
              refName="company"
              :placeholderText="'请填写合作单位基本情况'"
              v-model="ruleForm.company"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
            ></editor>
          </el-form-item>
        </el-row>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
          "
        >
          <h3 style="margin: 0">科研项目</h3>
          <el-button icon="el-icon-plus" type="success" @click="addList(1)"
            >新增科研项目</el-button
          >
        </div>
        <el-row
          v-for="(item, index) in ruleForm.A027"
          :key="'A027' + index"
          style="
            border: 1px solid #799ae1;
            margin-bottom: 5px;
            padding-top: 10px;
          "
        >
          <el-col :span="10">
            <el-form-item label="项目名称" :prop="'A027.' + index + '.name'">
              <el-input
                v-model="item.name"
                placeholder="请填写项目名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="项目经费总额" :prop="'A027.' + index + '.ed'">
              <el-input
                v-model.number="item.ed"
                @change="countNum()"
                placeholder="请填写项目经费总额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-show="index != 0">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="removeList(item, 1)"
            ></el-button>
          </el-col>
          <el-col>
            <el-form-item label="项目简介" :prop="'A027.' + index + '.jj'">
              <el-input
                type="textarea"
                placeholder="请填写项目简介"
                v-model="item.jj"
                maxlength="150"
                rows="4"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="项目经费总额(万元)" class="special">
              <el-input
                v-model="ruleForm.A028"
                placeholder="请填写项目经费总额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="研发投入比例(%)">
              <el-input
                v-model="ruleForm.A029"
                placeholder="请填写研发投入比例"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
          "
        >
          <h3 style="margin: 0">引进技术</h3>
          <el-button icon="el-icon-plus" type="success" @click="addList(2)"
            >新增引进技术</el-button
          >
        </div>
        <el-row
          v-for="(item, index) in ruleForm.A030"
          :key="'A030' + index"
          style="
            border: 1px solid #799ae1;
            margin-bottom: 5px;
            padding-top: 10px;
          "
        >
          <el-col :span="7">
            <el-form-item label="技术名称" :prop="'A030.' + index + '.name'">
              <el-input
                v-model="item.name"
                placeholder="请填写技术名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="技术来源" :prop="'A030.' + index + '.ly'">
              <el-input
                v-model="item.ly"
                placeholder="请填写技术来源"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="技术领域" :prop="'A030.' + index + '.jsly'">
              <el-input
                v-model="item.jsly"
                placeholder="请填写技术领域"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-show="index != 0">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="removeList(item, 2)"
            ></el-button>
          </el-col>
          <el-col>
            <el-form-item label="技术简介" :prop="'A030.' + index + '.jj'">
              <el-input
                type="textarea"
                placeholder="请填写技术简介"
                v-model="item.jj"
                maxlength="100"
                rows="4"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="鉴定成果数(项)">
              <el-input
                v-model="ruleForm.A031"
                placeholder="请填写鉴定成果数"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
          "
        >
          <h3 style="margin: 0">专利申请情况</h3>
          <el-button icon="el-icon-plus" type="success" @click="addList(3)"
            >新增专利</el-button
          >
        </div>
        <el-row
          v-for="(item, index) in ruleForm.A032"
          :key="'A032' + index"
          style="
            border: 1px solid #799ae1;
            margin-bottom: 5px;
            padding-top: 10px;
          "
        >
          <el-col :span="7">
            <el-form-item label="专利名称" :prop="'A032.' + index + '.name'">
              <el-input
                v-model="item.name"
                placeholder="请填写专利名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              style="text-align: left"
              label="是否授权"
              :prop="'A032.' + index + '.isSq'"
            >
              <el-switch
                @change="sqChange(index)"
                v-model="item.isSq"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="item.isSq">
            <el-form-item label="授权号" :prop="'A032.' + index + '.sqh'">
              <el-input
                v-model="item.sqh"
                placeholder="请填写授权号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-else>
            <el-form-item label="申请号" :prop="'A032.' + index + '.zlsqh'">
              <el-input
                v-model="item.zlsqh"
                placeholder="请填写申请号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-show="index != 0">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="removeList(item, 3)"
            ></el-button>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="获奖情况(项)">
              <el-input
                v-model="ruleForm.A033"
                placeholder="请填写获奖情况"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="国家级奖项(项)">
              <el-input
                v-model="ruleForm.A034"
                placeholder="请填写国家级奖项"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="省部级奖项(项)">
              <el-input
                v-model="ruleForm.A035"
                placeholder="请填写省部级奖项"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="5">
            <el-form-item style="text-align: left" label="是否推荐" prop="hot">
              <el-switch
                v-model="ruleForm.hot"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推荐度" prop="hot_order">
              <!-- <el-input v-model.number="ruleForm.hot_order" placeholder="请输入推荐度" :disabled="ruleForm.hot == 2"></el-input> -->
              <el-slider
                v-model="ruleForm.hot_order"
                show-input
                :disabled="ruleForm.hot == 2"
              ></el-slider>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
export default {
  components: {
    CommonLayout,
    editor,
  },
  data() {
    var validateHoto = (rule, value, callback) => {
      if (this.ruleForm.hot == 1) {
        if (!value) {
          callback(new Error("请设置推荐度"));
        }
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      fieldValue: "",
      is_submit: true,
      levelValue: "",
      total: 10,
      per_page: 10,
      current_page: 1,
      type: 0,
      time: "",
      Title: "",
      searchValue: "",
      dialogFormVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      deleteRow: "",
      fileList: [],
      tableData: [],
      dwlxOptions: [
        {
          value: "001",
          label: "科研院所",
        },
        {
          value: "002",
          label: "大专院校",
        },
        {
          value: "003",
          label: "企业",
        },
        {
          value: "004",
          label: "其他",
        },
      ],
      fieldOptions: [
        {
          value: "001",
          label: "农业",
        },
        {
          value: "002",
          label: "环境",
        },
        {
          value: "003",
          label: "轻工",
        },
        {
          value: "004",
          label: "医药",
        },
        {
          value: "005",
          label: "装备制造",
        },
        {
          value: "006",
          label: "能源",
        },
        {
          value: "007",
          label: "其他",
        },
      ],
      levelOptions: [
        {
          value: "001",
          label: "市级",
        },
        {
          value: "002",
          label: "省级",
        },
        {
          value: "003",
          label: "国家级",
        },
      ],
      ruleForm: {
        name: "",
        people: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        field: [],
        level: [],
        subject: "",
        unit: "",
        introduction: "",
        output: "",
        company: "",
        hot: 2,
        hot_order: 0,
        A001: "",
        A002: "",
        A003: "",
        A004: "",
        A005: "",
        A006: "",
        A007: "",
        A008: "",
        A009: "",
        A010: "",
        A011: "",
        A012: "",
        A013: "",
        A015: "",
        A016: "",
        A017: "",
        A018: "",
        A019: "",
        A020: "",
        A021: "",
        A022: "",
        A023: "",
        A024: "",
        A024: "",
        A028: "",
        A029: "",
        A031: "",
        A033: "",
        A034: "",
        A035: "",
        A026: [],
        A027: [
          {
            name: "",
            ed: "",
            jj: "",
          },
        ],
        A030: [
          {
            name: "",
            ly: "",
            jsly: "",
            jj: "",
          },
        ],
        A032: [
          {
            name: "",
            isSq: false,
            sqh: "",
            zlsqh: "",
          },
        ],
        A036: "",
      },
      rules: {
        detailed: [
          {
            validator: (rule, value, callback) =>
              this.CheckAddress(rule, value, callback, this.ruleForm),
            required: true,
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
        people: [
          { required: true, message: "请输入服务人数", trigger: "blur" },
        ],
        logo: [{ required: true, message: "请上传logo", trigger: "blur" }],
        field: [
          { required: true, message: "请选择从事领域", trigger: "change" },
        ],
        A026: [
          { required: true, message: "请选择单位类型", trigger: "change" },
        ],
        level: [{ required: true, message: "请选择级别", trigger: "change" }],
        subject: [
          { required: true, message: "请输入申报单位名称", trigger: "blur" },
        ],
        unit: [{ required: true, message: "请输入合作单位", trigger: "blur" }],
        introduction: [
          {
            required: true,
            message: "请输入本单位的基本情况与工作基础",
            trigger: "blur",
          },
        ],
        output: [
          {
            required: true,
            message: "请输入近三年技术引进和成果产出情况",
            trigger: "blur",
          },
        ],
        company: [
          {
            required: true,
            message: "请输入合作单位基本情况",
            trigger: "blur",
          },
        ],
        hot_order: [
          { required: true, validator: validateHoto, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // this.getData("Resource_Result?all=1&page=" + this.current_page);
    this.getData();
  },
  methods: {
    // release(row,type){
    //   let obj = {};
    //   obj.id = row.id;
    //   obj.type = 12;
    //   obj.hot = 1;
    // },
    getData(url) {
      let params = {
        all: 1,
        page: this.current_page,
        name: this.searchValue,
        field: this.fieldValue || '',
        level: this.levelValue || ''
      };

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-result/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page * 1;
        }
      });
    },
    //计算项目经费总额
    countNum() {
      this.ruleForm.A028 = 0;
      this.ruleForm.A027.forEach((item) => {
        this.ruleForm.A028 += item.ed;
      });
    },
    //城市选择
    citySelected(e) {
      this.ruleForm.address = e;
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.introduction = val;
    },
    getQuillData1(val) {
      this.ruleForm.A024 = val;
    },
    getQuillData2(val) {
      this.ruleForm.company = val;
    },
    getQuillData4(val) {
      this.ruleForm.A025 = val;
    },
    addList(type) {
      if (type == 1) {
        this.ruleForm.A027.push({
          name: "",
          ed: "",
          jj: "",
        });
      }
      if (type == 2) {
        this.ruleForm.A030.push({
          name: "",
          ly: "",
          jsly: "",
          jj: "",
        });
      }
      if (type == 3) {
        this.ruleForm.A032.push({
          name: "",
          isSq: false,
          sqh: "",
          zlsqh: "",
        });
      }
    },
    removeList(item, type) {
      if (type == 1) {
        let index = this.ruleForm.A027.indexOf(item);
        if (index !== -1) {
          this.ruleForm.A027.splice(index, 1);
        }
      }
      if (type == 2) {
        let index = this.ruleForm.A030.indexOf(item);
        if (index !== -1) {
          this.ruleForm.A030.splice(index, 1);
        }
      }
      if (type == 3) {
        let index = this.ruleForm.A032.indexOf(item);
        if (index !== -1) {
          this.ruleForm.A032.splice(index, 1);
        }
      }
    },
    sqChange(index) {
      this.ruleForm.A032[index].sqh = "";
      this.ruleForm.A032[index].zlsqh = "";
    },
    //新增
    addEvent() {
      this.is_submit = true;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.fileList = [];
      this.ruleForm = {
        name: "",
        people: "",
        logo: "",
        image: "",
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        detailed: "",
        field: [],
        level: [],
        subject: "",
        unit: "",
        introduction: "",
        output: "",
        company: "",
        hot: 2,
        hot_order: 0,
        A001: "",
        A002: "",
        A003: "",
        A004: "",
        A005: "",
        A006: "",
        A007: "",
        A008: "",
        A009: "",
        A010: "",
        A011: "",
        A012: "",
        A013: "",
        A015: "",
        A016: "",
        A017: "",
        A018: "",
        A019: "",
        A020: "",
        A021: "",
        A022: "",
        A023: "",
        A024: "",
        A024: "",
        A028: "",
        A029: "",
        A031: "",
        A033: "",
        A034: "",
        A035: "",
        A026: [],
        A027: [
          {
            name: "",
            ed: "",
            jj: "",
          },
        ],
        A030: [
          {
            name: "",
            ly: "",
            jsly: "",
            jj: "",
          },
        ],
        A032: [
          {
            name: "",
            isSq: false,
            sqh: "",
            zlsqh: "",
          },
        ],
        A036: "",
      };
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-result/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.getData();
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  this.ResetSearch(["searchValue", "fieldValue", "levelValue"]);
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //搜索
    search() {
      this.current_page = 1;
      this.getData(
        "Resource_Result?all=1&name=" +
          this.searchValue +
          "&page=" +
          this.current_page +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.levelValue ? "&level=" + this.levelValue : "")
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true;
      this.dialogFormVisible = true;
      this.Title = "编辑";
      row.detailed = row.address ? row.address.detailed : "";
      row.address = row.address
        ? row.address
        : { province: { value: "" }, city: { value: "" }, area: { value: "" } };
      this.ruleForm = JSON.parse(JSON.stringify(row));
      this.ruleForm.level = row.level?.split(",") || [];
      this.ruleForm.field = row.field?.split(",") || [];
      this.ruleForm.A026 = row.A026?.split(",") || [];
      this.ruleForm.A027 = JSON.parse(row.A027);
      this.ruleForm.A030 = JSON.parse(row.A030);
      this.ruleForm.A032 = JSON.parse(row.A032);
      // this.ruleForm.detailed = row.address.detailed
      this.fileList = [];
      if (row.image) {
        let arr = [];
        arr = row.image.split(",");
        arr.forEach((item, index) => {
          this.fileList.push({
            name: "download.jpg",
            url: this.imgUrl + item,
            store_result: item,
            uid: new Date().getTime() + index,
          });
        });
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http
            .request(`${urlConfig.devUrl}apij2/admin-api/trade/resource-result/delete?id=` + row.id, "", "delete")
            .then((res) => {
              if (res.code == 0) {
                this.getData();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.ResetSearch(["searchValue", "fieldValue", "levelValue"]);
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //翻页
    handleCurrentChange(e) {
      this.getData(
        "Resource_Result?all=1&name=" +
          this.searchValue +
          "&page=" +
          e +
          (this.fieldValue ? "&field=" + this.fieldValue : "") +
          (this.levelValue ? "&level=" + this.levelValue : "")
      );
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //获取经纬度
    factory(name) {
      this.$jsonp(
        "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          this.ruleForm.detailed +
          "&city=" +
          this.ruleForm.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
        .then((json) => {
          let arr = json.pois[0].location.split(",");
          this.ruleForm.longitude = arr[0];
          this.ruleForm.latitude = arr[1];
          this.subData(name);
        })
        .catch((err) => {
          this.is_submit = true;
          this.$message.error("未获取到经纬度,请查看地址是否完整");
        });
    },
    subData(name) {
      let obj = JSON.parse(JSON.stringify(this.ruleForm));
      let arr = [];
      this.fileList.forEach((item) => {
        if (item.response) {
          arr.push(item.response.data.store_result);
        } else {
          arr.push(item.store_result);
        }
      });
      obj.image = arr.join(",");
      obj.address.detailed = this.ruleForm.detailed;
      obj.field = this.ruleForm.field.join(",");
      obj.level = this.ruleForm.level.join(",");
      obj.A026 = this.ruleForm.A026.join(",");
      obj.A027 = JSON.stringify(obj.A027);
      obj.A030 = JSON.stringify(obj.A030);
      obj.A032 = JSON.stringify(obj.A032);
      obj.date_time = new Date().format("yyyy-MM-dd hh:mm:ss");
      let area = [
        {
          name: "兰州市",
          id: "001",
        },
        {
          name: "嘉峪关市",
          id: "002",
        },
        {
          name: "金昌市",
          id: "003",
        },
        {
          name: "白银市",
          id: "004",
        },
        {
          name: "天水市",
          id: "005",
        },
        {
          name: "武威市",
          id: "006",
        },
        {
          name: "张掖市",
          id: "007",
        },
        {
          name: "酒泉市",
          id: "008",
        },
        {
          name: "平凉市",
          id: "009",
        },
        {
          name: "庆阳市",
          id: "010",
        },
        {
          name: "定西市",
          id: "011",
        },
        {
          name: "陇南市",
          id: "012",
        },
        {
          name: "临夏回族自治州",
          id: "013",
        },
        {
          name: "甘南藏族自治州",
          id: "014",
        },
      ];
      area.forEach((item) => {
        if (obj.address.city.value == item.name) {
          obj.area = item.id;
        }
      });
      if (obj.hot == 2) {
        obj.hot_order = 0;
      }
      delete obj.detailed;
      if (!this.ruleForm.id) {
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-result/create`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData();
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.dialogFormVisible = false;
              this.$refs[name].resetFields();
              let obj1 = {
                name: obj.name,
                moudle: "产学研科技合作基地",
                date_time: obj.date_time,
              };
              this.ResetSearch(["searchValue", "fieldValue", "levelValue"]);

              this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/index-resource/create`, obj1);
            } else {
              this.is_submit = true;
            }
          })
          .catch((err) => {
            this.is_submit = true;
          });
      }
      if (this.Title == "编辑") {
        // delete obj.id;
        obj.id = this.ruleForm.id;
        this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-result/update`, obj)
          .then((res) => {
            if (res.code == 0) {
              this.getData();
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.ResetSearch(["searchValue", "fieldValue", "levelValue"]);

              this.dialogFormVisible = false;
              this.$refs[name].resetFields();
            } else {
              this.is_submit = true;
            }
          })
          .catch((err) => {
            this.is_submit = true;
          });
      }
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.factory(name);
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.ruleForm.logo = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    handlePictureCardPreview(file) {
      this.ruleForm.logo = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.ruleForm.logo = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //上传照片墙
    HouImgFile1(e) {
      var files = e.file;
      if (!files) return;
      this.createImage1(files, e, "HouImg");
    },
    //其他图片上传
    createImage1(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.fileList.push({
                name: file.name,
                url: this.imgUrl + res.data,
                store_result: res.data,
                uid: file.uid,
              });
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    //移除
    handleRemove1(file, fileList) {
      this.fileList = fileList;
    },
    //上传前
    beforeUpload1(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    //查看
    pictureCardPreview1(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scope>
.transform {
  height: 100%;
  width: 100%;
  .transform-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .el-select {
      margin: 0 15px;
      .el-input {
        margin: 0;
      }
    }
    /deep/.el-input--suffix {
      width: 100%;
    }
    .el-input {
      // width: 400px;
      margin: 0 15px;
    }
    .date-picker {
      margin: 0 15px;
      .el-range-separator {
        width: auto;
      }
    }
  }
  .transform-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
